export const attendeeToSheetRow = (attendee, pk) => [
    [
        attendee.vendorName,
        attendee.vendorId,
        pk,
        attendee.firstName,
        attendee.lastName,
        attendee.textField1,
        attendee.address,
        attendee.city,
        attendee.state,
        attendee.zip,
        attendee.email,
        attendee.phone,
        attendee.textField2
    ]
];



// WEBPACK FOOTER //
// ./src/event/attendeeToSheetRow.js